export const generatePortraits = async (imageData) => {
  try {
    const response = await fetch(
      "https://image-to-portrait-660323987151.us-central1.run.app",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ image: imageData }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error generating portraits:", error);
    throw error;
  }
};

export const generateApplicationMaterials = async (formData, targetJobs) => {
  const apiCalls = targetJobs.map(async (job, index) => {
    const payload = {
      ...formData,
      targetJobInformation: [job],
    };

    // Log the payload to inspect its contents, especially targetJobInformation
    console.log("Sending payload for job:", job);
    console.log("Full payload:", JSON.stringify(payload, null, 2));
    if (
      payload.targetJobInformation &&
      payload.targetJobInformation[0] &&
      payload.targetJobInformation[0].companyName
    ) {
      console.log(
        "Target Company Name:",
        payload.targetJobInformation[0].companyName
      );
    } else {
      console.log("Target Company Name: Not found in payload");
    }

    try {
      const response = await fetch(
        // "https://us-central1-resumerevivalapp.cloudfunctions.net/prod_process_application",
        // "https://us-central1-resumerevivalapp.cloudfunctions.net/dev_o3_mini_resume",
        // "https://us-central1-resumerevivalapp.cloudfunctions.net/dev_process_application",
        "https://us-central1-resumerevivalapp.cloudfunctions.net/prod_process_application",
        // ""
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get the raw response text
      const rawResponse = await response.text();

      // logging
      // console.log(`Raw response for job ${index + 1}:`);
      // console.log(rawResponse);

      // Parse the response as JSON and return it
      return JSON.parse(rawResponse);
    } catch (error) {
      console.error(`Error for job ${index + 1}:`, error);
      throw error;
    }
  });

  return Promise.all(apiCalls);
};
